import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const DocusaurusPage = () => {
  const location = useLocation();
  const openedRef = useRef(false);

  useEffect(() => {
    if (openedRef.current) return;

    const redirectTo = `/app${location.pathname.endsWith('/') ? location.pathname : `${location.pathname}/`}index.html`;
    window.open(redirectTo, '_blank', 'noopener,noreferrer');
    openedRef.current = true;
    window.history.back();
  }, [location]);

  return null;
};

export default DocusaurusPage;
